<template>
  <v-form ref="form" v-model="valid" lazy-validation>
    <v-card>
      <v-card-title>
        <span class="text-h5">{{
          isEdit
            ? "Editar Asignación de Presupuesto"
            : "Asignación de Presupuesto"
        }}</span>
      </v-card-title>
      <v-card-text>
        <v-container>
          <!-- Campos principales del formulario de presupuesto -->
          <v-row class="py-md-0 my-md-n7">
            <v-col cols="12" sm="4" md="3">
              <v-subheader>Autorización</v-subheader>
            </v-col>
            <v-col cols="12" sm="8" md="8">
              <v-text-field v-model="localItem.cite" solo readonly required />
            </v-col>
          </v-row>
          <v-row class="py-md-0 my-md-n7">
            <v-col cols="12" sm="4" md="3">
              <v-subheader>Programa</v-subheader>
            </v-col>
            <v-col cols="12" sm="8" md="8">
              <v-text-field v-model="localItem.unidad" solo readonly required />
            </v-col>
          </v-row>
          <v-row class="py-md-0 my-md-n7">
            <v-col cols="12" sm="4" md="3">
              <v-subheader>Periodo de Comisión</v-subheader>
            </v-col>
            <v-col cols="12" sm="4" md="4">
              <v-text-field
                v-model="localItem.periodoIda"
                solo
                readonly
                required
              />
            </v-col>
            <v-col cols="12" sm="4" md="4">
              <v-text-field
                v-model="localItem.periodoVuelta"
                solo
                readonly
                required
              />
            </v-col>
          </v-row>
          <v-row class="py-md-0 my-md-n7">
            <v-col cols="12" sm="4" md="3">
              <v-subheader>Viatico Financiamiento</v-subheader>
            </v-col>
            <v-col cols="12" sm="4" md="4">
              <v-text-field
                v-model="localItem.viatico"
                solo
                readonly
                required
                suffix="DIA(S)"
              />
            </v-col>
            <v-col cols="12" sm="4" md="4">
              <v-text-field
                v-model="localItem.financiamiento"
                suffix="Bs."
                solo
                readonly
                required
              />
            </v-col>
          </v-row>
          <v-row class="py-md-0 my-md-n6">
            <v-col cols="12" sm="4" md="3">
              <v-subheader>Saldo Pasaje/Viatico</v-subheader>
            </v-col>
            <v-col cols="12" sm="4" md="4">
              <v-text-field
                v-model="localItem.pasaje"
                suffix="Bs."
                type="number"
                solo
                readonly
                required
              />
            </v-col>
            <v-col cols="12" sm="4" md="4">
              <v-text-field
                v-model="localItem.salViatico"
                suffix="Bs."
                type="number"
                solo
                readonly
                required
              />
            </v-col>
          </v-row>

          <!-- Sección de Pasajes Terrestres -->
          <v-list
            two-line
            v-if="localItem.transporte == 2 || localItem.transporte == 5"
          >
            <div
              v-for="(pasaje, index) in localItem.pasajeTerr"
              :key="'pasaje-' + index"
            >
              <div class="mb-md-3 mt-md-5">
                {{ "Pasaje Terrestre N° " + (index + 1) }}
              </div>
              <v-list-item>
                <v-list-item-action>
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        icon
                        v-bind="attrs"
                        v-on="on"
                        color="error"
                        @click="removePasaje(index)"
                      >
                        <v-icon>remove_circle_outline</v-icon>
                      </v-btn>
                    </template>
                    <span>Eliminar Pasaje</span>
                  </v-tooltip>
                </v-list-item-action>
                <v-list-item-content class="py-md-1 my-md-n6">
                  <v-col cols="12" sm="4" md="6">
                    <v-text-field
                      v-model="pasaje.pasaje"
                      type="number"
                      step="0.1"
                      max="999.99"
                      label="Pasaje Terrestre"
                      :rules="[(v) => v > -0.00001 || 'Cifra incorrecta']"
                      suffix="Bs."
                      class="inputPrice"
                      required
                    />
                  </v-col>
                  <v-col cols="12" sm="4" md="6">
                    <v-text-field
                      v-model="pasaje.factura"
                      type="number"
                      label="Factura Terrestre"
                      class="inputPrice"
                      required
                    />
                  </v-col>
                </v-list-item-content>
                <v-list-item-action>
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        icon
                        v-bind="attrs"
                        v-on="on"
                        color="success"
                        @click="addPasaje()"
                      >
                        <v-icon>add_circle_outline</v-icon>
                      </v-btn>
                    </template>
                    <span>Adicionar Pasaje</span>
                  </v-tooltip>
                </v-list-item-action>
              </v-list-item>
            </div>
          </v-list>

          <!-- Sección de Boletos Aéreos -->
          <v-list
            two-line
            v-if="localItem.transporte == 1 || localItem.transporte == 5"
          >
            <div
              v-for="(boleto, index) in localItem.boletoAereo"
              :key="'boleto-' + index"
            >
              <div class="mb-md-3 mt-md-5">
                {{ "Boleto de Avion N° " + (index + 1) }}
              </div>
              <v-list-item>
                <v-list-item-action>
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        icon
                        v-bind="attrs"
                        v-on="on"
                        color="error"
                        @click="removeBoleto(index)"
                      >
                        <v-icon>remove_circle_outline</v-icon>
                      </v-btn>
                    </template>
                    <span>Eliminar Boleto</span>
                  </v-tooltip>
                </v-list-item-action>
                <v-list-item-content>
                  <v-col cols="12" sm="4" md="4">
                    <v-select
                      v-model="boleto.lineaAerea"
                      :items="lineasAereas"
                      label="Línea Aérea"
                      required
                    />
                  </v-col>
                  <v-col cols="12" sm="4" md="4">
                    <v-text-field
                      v-model="boleto.reBoleto"
                      label="Codigo Boleto"
                      required
                    />
                  </v-col>
                  <v-col cols="12" sm="4" md="4">
                    <v-text-field
                      v-model="boleto.pasAereo"
                      type="number"
                      step="0.1"
                      label="Pasaje Aereo"
                      :rules="[
                        (v) => v > -0.00001 || 'Cifra incorrecta',
                        (v) => !!v || 'Pasaje Aereo es Requerido',
                      ]"
                      class="inputPrice"
                      suffix="Bs."
                      required
                    />
                  </v-col>
                </v-list-item-content>
                <v-list-item-action>
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        icon
                        v-bind="attrs"
                        v-on="on"
                        color="success"
                        @click="addBoleto()"
                      >
                        <v-icon>add_circle_outline</v-icon>
                      </v-btn>
                    </template>
                    <span>Añadir Boleto</span>
                  </v-tooltip>
                </v-list-item-action>
              </v-list-item>
            </div>
          </v-list>
        </v-container>
      </v-card-text>
      <v-card-actions>
        <v-spacer />
        <v-btn color="blue darken-1" text @click="onCancel">Cancelar</v-btn>
        <v-btn :disabled="!valid" color="blue darken-1" text @click="onSave"
          >Guardar</v-btn
        >
      </v-card-actions>
    </v-card>
  </v-form>
</template>
<script>
export default {
  name: "PresupuestoForm",
  props: {
    value: { type: Object, required: true },
    isEdit: { type: Boolean, default: false },
    lineasAereas: { type: Array, default: () => [] },
  },
  data() {
    return {
      localItem: { ...this.value },
      valid: false,
    };
  },
  created() {
    if (!this.localItem.transporte) {
      this.$set(this.localItem, "transporte", 2); // 2 = Terrestre por defecto
    }
  },
  watch: {
    value: {
      handler(newVal) {
        this.localItem = { ...newVal };
        if (!this.localItem.transporte) {
          this.$set(this.localItem, "transporte", 2);
        }
      },
      deep: true,
      immediate: true,
    },
  },
  methods: {
    onSave() {
      if (this.$refs.form.validate()) {
        // Normalizar pasajes terrestres
        if (Array.isArray(this.localItem.pasajeTerr)) {
          this.localItem.pasajeTerr = this.localItem.pasajeTerr.map((p) => ({
            ...p,
            pasaje: p.pasaje == null || p.pasaje === "" ? 0 : p.pasaje,
            factura: !p.factura ? "-" : p.factura,
          }));
        }
        this.$emit("save", { ...this.localItem });
      }
    },
    onCancel() {
      this.$emit("cancel");
    },
    addPasaje() {
      this.localItem.pasajeTerr.push({
        id: null,
        pasaje: null,
        factura: null,
      });
    },
    removePasaje(index) {
      if (this.localItem.pasajeTerr.length <= 1) {
        alert("Se requiere minimo un Pasaje Terrestre");
      } else {
        this.localItem.pasajeTerr.splice(index, 1);
      }
    },
    addBoleto() {
      this.localItem.boletoAereo.push({
        id: null,
        reBoleto: null,
        lineaAerea: null,
        pasAereo: null,
      });
    },
    removeBoleto(index) {
      if (this.localItem.boletoAereo.length <= 1) {
        alert("Se requiere un Boleto");
      } else {
        this.localItem.boletoAereo.splice(index, 1);
      }
    },
  },
};
</script>
